<template>
  <div class="AnaliseReceita">
    <h1>Análise de Receita</h1>
    <form onsubmit="return false" @submit="load" class="filter row justify-space">
      <div class="grid-1 column">
        <label style="margin-bottom: 12px">Registros</label>
        {{ list.faturamentos_clientes ? list.faturamentos_clientes.length : 0 }}
      </div>
      <div class="grid-2 column">
        <label>Status Faturamento</label>
        <select v-model="filter.status_faturamento">
          <option value="">Selecione</option>
          <option value="nao_faturado">Não faturado</option>
          <option value="faturado">Faturado</option>
          <option value="perda">Perda</option>
        </select>
      </div>
      <div class="grid-2 column">
        <label>Data Referência</label>
        <select v-model="filter.tipo_data" required>
          <option value="">Selecione</option>
          <option value="abertura">Abertura</option>
          <option value="atendimento">Atendimento</option>
          <option value="fechamento">Fechamento</option>
        </select>
      </div>
      <div class="grid-2 column">
        <label>Data inicial</label>
        <input type="date" v-model="di" :disabled="!filter.tipo_data" :class="!filter.tipo_data && 'dd'" />
      </div>
      <div class="grid-2 column">
        <label>Data final</label>
        <input type="date" v-model="df" :disabled="!filter.tipo_data" :class="!filter.tipo_data && 'dd'" />
      </div>
      <div class="grid-1 column justify-end"><Button v-if="di && df && filter.tipo_data" layout="green-go" @click="load" :loader="loader">Gerar</Button></div>
    </form>
    <template v-if="list.total_faturamento_fechado">
      <div class="totais row">
        <div class="grid-2">Total</div>
        <div class="grid-2 text-center">{{ list.total_faturamento_fechado | money }}</div>
        <div class="grid-2 text-center">{{ list.total_faturamento_finalizado | money }}</div>
        <div class="grid-2 text-center">{{ list.total_faturamento_pendente | money }}</div>
        <div class="grid-2 text-center">{{ (list.total_faturamento_fechado + list.total_faturamento_finalizado +
          list.total_faturamento_pendente) | money }}</div>
      </div>
      <div class="content">
        <div class="head row grid-12">
          <div class="grid-2"><input v-model="search" placeholder="Cliente" /></div>
          <div class="grid-2 text-center">Job fechados</div>
          <div class="grid-2 text-center">Prontos <i class="fa fa-question-circle font-13 tip">
              <div>Jobs Finalizados prontos para fechamento</div>
            </i></div>
          <div class="grid-2 text-center">Pendente <i class="fa fa-question-circle font-13 tip">
              <div>Jobs com status Categorizado ou superior</div>
            </i></div>
          <div class="grid-2 text-center">Total</div>
        </div>
        <div class="container">
          <div class="row line" v-for="f of filtered" :key="f.nome_cliente">
            <div class="grid-2">{{ f.nome_cliente }}</div>
            <div class="grid-2 text-center">{{ f.total_faturamento_fechado | money }}</div>
            <div class="grid-2 text-center">{{ f.total_faturamento_finalizado | money }}</div>
            <div class="grid-2 text-center">{{ f.total_faturamento_pendente | money }}</div>
            <div class="grid-2 text-center">{{ f.total_faturamento | money }}</div>
          </div>
        </div>
      </div>
    </template>
    <div v-else class="fb tc cr font-20" style="margin-top:10%">NENHUM FATURAMENTO.</div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button";

export default {
  name: "AnaliseReceita",
  components: {
    Button
  },
  data() {
    return {
      search: "",
      filter: {
        status_faturamento: "",
        tipo_data: ""        
      },
      di: "",df:"",
      list: { faturamentos_clientes: [] },
      loader: false
    }
  },
  methods: {
    ...mapActions("admin", ["ANALISE_RECEITA"]),
    async load() {
      this.loader = true
      let p = {...this.filter}
    
      if(this.filter.tipo_data=='abertura') (p.data_abertura_inicial = this.di, p.data_abertura_final = this.df)
      if(this.filter.tipo_data=='atendimento') (p.data_atendimento_inicial = this.di, p.data_atendimento_final = this.df)
      if(this.filter.tipo_data=='fechamento') (p.data_fechamento_inicial = this.di, p.data_fechamento_final = this.df)
      
      if(!p.status_faturamento) delete p.status_faturamento
      await this.ANALISE_RECEITA(p).then(({ data }) => this.list = data || {})
      this.loader = false
    }
  },
  computed: {
    filtered() {
      if (this.search.length) {
        let s = this.search.toLowerCase();
        return this.list.faturamentos_clientes.filter(f => f.nome_cliente.toLowerCase().includes(s))
      }
      return this.list.faturamentos_clientes
    }
  }
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.AnaliseReceita
  padding: 28px 40px
  label
    @include label
  .filter
    background: none
    padding: 10px
    border: none
    font-size: 26px
    button
      height: 50px
  .totais
    background: rgba($purple, .5)
    padding: 10px 20px
    border-radius: 4px
    margin: 20px 0
    font-size: 20px
  .content
    border-radius: 8px
    background: white
    @include border
  .head
    color: $purple
    font-size: 20px
    padding: 20px
    input
      box-shadow: none
      border-bottom: 1px solid #ccc
      margin-top: -22px
      color: $purple
      border-radius: 0
      &:focus
        border-bottom: 1px solid $purple
  .dd
    background: #eee
  .line
    padding: 10px 20px
    &:nth-child(odd)
      background: #eee
  .container
    max-height: 500px
    overflow: auto
    border-top: 1px solid $purple
   
    

</style>
